<template>
  <div class="held-charge-details-display">
    <div class="row">
      <div class="col-md-5">
        <h4>Pre-Authorization Details</h4>
        <p>Will be held until: {{ releaseDate | short_date_format}}</p>
        <div class="list-group-item">
          <div class="row">
            <div class="col-xs-9">
              <p><strong>Amount held</strong></p>
            </div>
            <div class="col-xs-3 text-right">
              <p>{{ parseFloat(heldCharge.cost) | currency_round }}</p>
            </div>
          </div>
          <hr/>
          <template v-for="charge in heldCharge.ReservationCharges">
            <div class="row">
              <div class="col-xs-9">
                <p><a v-link="{ path: '/reservation/' + charge.ReservationUuid }">{{ charge.description }}</a></p>
              </div>
              <div class="col-xs-3 text-right">
                <p class="red">{{ charge.cost | currency_round }}</p>
              </div>
            </div>
          </template>
          <template v-for="charge in heldCharge.BulkCharges">
            <div class="row">
              <div class="col-xs-9">
                <p><a v-link="{ path: '/charge/' + charge.uuid }">{{ charge.description }}</a></p>
              </div>
              <div class="col-xs-3 text-right">
                <p class="red">{{ charge.cost | currency_round }}</p>
              </div>
            </div>
          </template>
          <div class="row">
            <hr/>
            <div class="col-xs-9">
              <p><strong>Total to be captured</strong></p>
            </div>
            <div class="col-xs-3 text-right">
              <p class="red">{{ heldCharge.captureAmount | currency_round }}</p>
            </div>
          </div>
          <div class="row">
            <hr/>
            <div class="col-xs-9">
              <p><strong>Total to be released</strong></p>
            </div>
            <div class="col-xs-3 text-right">
              <p class="green">{{ parseFloat(heldCharge.cost) - parseFloat(heldCharge.captureAmount) | currency_round }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HeldChargeDisplay',
  data () {
    return {
      heldCharge: {
        BulkCharges: [],
        ReservationCharges: []
      },
      releaseDate: moment()
    }
  },
  route: {
    data () {
      this.refreshData()
    }
  },
  methods: {
    refreshData () {
      let params = this.$route.params
      let authType = this.$route.authType
      this.$http.get(`${authType}/held-charge`, { params }).then(({ data }, status, request) => {
        this.heldCharge = data
        this.releaseDate = moment(this.heldCharge.createdAt).add(6, 'days')
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// HeldChargeDisplay.vue?23403275